// TODO: apagar esse abaixo
export interface IStepTracker {
  id: string,
  label: string,
  state: 'default' | 'completed' | 'current'
}

// TODO: usar apenas os debaixo
export interface IStepSchedule {
  id: number;
  hasTracker: boolean;
  hasFooter: boolean;
  route: string;
  tracker: ITrackerStep;
  footer: IFooterStep;
}

interface ITrackerStep {
  title: string;
  state: 'default' | 'completed' | 'current';
}

interface IFooterStep {
  leftButton: IButtonStep;
  rightButton: IButtonStep;
  navigateStepToStep?: (change: boolean) => void;
}

interface IButtonStep {
  id: string;
  label: string;
  enabled: boolean;
  visible: boolean;
}
